import React from "react";
import { Props } from "./types";

function OrganizationalUnitIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 18 16">
      <path d="M7,0 h4 v4 h-4 Z M8.25,4 h1.5 v3.25 h-1.5 Z M1,7.25 h16 v1.5 h-16 Z M1.25,8.75 h1.5 v3.25 h-1.5 Z M15.25,8.75 h1.5 v3.25 h-1.5 Z M0,12 h4 v4 h-4 Z M14,12 h4 v4 h-4 Z" />
    </svg>
  );
}

export { OrganizationalUnitIcon };
